import { createSlice } from "@reduxjs/toolkit";

const stateSlice = createSlice({
  name: "state",
  initialState: {},
  reducers: {
    setState: (state: any, action) => {
      state[action.payload.key] = {
        data: action.payload.value,
        timestamp: Date.now(),
      };
    },
    deleteAllState: (state: any) => {
      Object.keys(state).forEach((key) => {
        delete state[key];
      });
    },
  },
});

export const { setState, deleteAllState } = stateSlice.actions;
export default stateSlice.reducer;
